<template>
    <transition name="slide-in">
        <ModalControl title="Centered Modal" :is_visible="is_modal_open">
            <div v-if="this.type == 7 && this.is_editing_info">
                <div class="flex flex-row items-center justify-between">
                    <LabelControl :content="$t('mip009')"></LabelControl>
                    <IconControl @click="this.closeEditModal()" id="exit-black" :width="50" :height="50" />
                </div>

                <KeypadControl @digits-full="saveDigits" @digits-changed="updateDigits" @digits-cleared="clearDigits"
                    :limit="10" input_type="mobile" />

                <div class="flex w-full justify-center align-center text-center" style="margin-top: -2rem;">
                    <div class="otp-button" style="width: 37rem;">
                        <ButtonControl @click="submitMobile(new_mobile)" :disabled="isButtonDisabled"
                            :button_loading="loading" class='w-full' :text="$t('btn002')" />
                    </div>

                </div>
            </div>

            <div v-if="type === 6 && this.is_editing_info">
                <div class="flex flex-row items-center justify-between p-5">
                    <LabelControl :content="$t('mip010')"></LabelControl>
                    <IconControl @click="this.closeEditModal()" id="exit-black" :width="50" :height="50" />
                </div>

                <!-- Email Input Section -->
                <div class="mt-10 mx-5 rounded-lg">
                    <transition name="slide-in">
                        <KeyboardControl v-model="new_email" type="email" :placeholder="email" :overlay_enabled="false"
                            :is_email="true" :max_length="40" :loading="loading" @submit="submitEmail">

                            <div class="flex flex-row items-center justify-between mb-10 w-full">
                                <h2 class="text-primary uppercase text-5xl font-bold">{{ $t('mip010') }}</h2>
                                <IconControl @click="this.closeEditModal()" id="exit-black" :width="50" :height="50" />
                            </div>

                        </KeyboardControl>
                    </transition>

                </div>
            </div>

            <div v-else-if="this.is_requesting_otp">
                <div class="flex flex-row items-center justify-between">
                    <LabelControl v-if="type == 14 || type == 6 || type == 7" :content="$t('otp004')" />
                    <IconControl @click="this.closeEditModal()" id="exit-black" :width="50" :height="50" />
                </div>
                <!-- <p v-if="this.is_enrolling_pin" class="text-left mt-6 text-3xl">{{ $t('otp005') }}</p> -->
                <KeypadControl :input_type="'OTP'" :limit="6" @digits-full="saveOTP" @digits-changed="updatePin"
                    @digits-cleared="clearPin" />

                <div class="flex w-full justify-center items-center text-center" style="margin-top: -2rem;">
                    <div class="flex flex-col justify-center items-center text-center w-full">
                        <ButtonControl class="verify-btn" @click="validateOTP" :disabled="!isOTPValid" :button_loading="disable_button"
                         :text="$t('btn009')" />
                        <div class="flex flex-row text-2xl pb-5 justify-center items-center text-center">
                            <p class="mr-2">{{ $t('msg009') }}</p>
                            <button v-if="this.can_resend_otp" @click="resendOTP"
                                class="text-primary font-bold underline">{{ $t('otp001') }}</button>
                            <p v-else class="text-grey-darker">{{ $t('otp002') }} {{ modal_countdown }} {{ $t('otp003')
                                }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </ModalControl>
    </transition>

    <transition name="slide-in">
        <EditPINModalControl :is_editing_pin="false" ref="editPINModal" />    
    </transition>

    <!-- Existing Session -->
    <transition name="slide-in">
        <ModalControl :is_visible="this.existing_session">
            <SessionTimeoutControl />
        </ModalControl>
    </transition>

    <!-- Update successful -->
    <transition name="slide-in">
        <ModalControl :is_visible="this.toggle_message">
            <div class="flex flex-col justify-center align-center items-center p-8">
                <img :src="getIcon('check')" class="mb-10">
                <LabelControl type="heading" class="text-grey-darkest font-bold text-5xl mb-8 text-center"
                    :content="$t('mip016')" />
                <div class="flex w-full text-center justify-center align-center items-center">
                    <ButtonControl :text="$t('btn014')" theme="success" @click="toggleMessage" />
                </div>
            </div>
        </ModalControl>
    </transition>

    <!-- Privacy Policy -->
    <transition name="slide-in">
        <ModalControl :is_visible="this.toggle_privacy" is_scrollable is_table :overlay_enabled="false">
            <div class="flex flex-col justify-center pt-10 px-10">
              <LabelControl type="dynamic" class="text-grey-darkest font-bold text-6xl mb-8 uppercase text-center"
              content="Privacy Policy" />
                            
              <PrivacyPolicyControl/>

                <div class="flex flex-row justify-center align-center items-center w-full" style="gap: 3rem;">
                  <ButtonControl text="I Disagree" theme="error" @click="toggle_privacy = false" class="w-full"/>
                  <ButtonControl text="I Agree" class="px-8 mr-5 w-full" theme="success" @click="submitBirthdate" />
                </div>
            </div>
        </ModalControl>
    </transition>

</template>

<script>
import LabelControl from '@/components/controls/LabelControl.vue';
import ModalControl from '@/components/controls/ModalControl.vue';
import KeypadControl from '@/components/controls/KeypadControl.vue';
import ButtonControl from '@/components/controls/ButtonControl.vue';
import EditPINModalControl from '@/components/controls/EditPINModalControl.vue';
import PrivacyPolicyControl from '@/components/controls/PrivacyPolicyControl.vue';
import SessionTimeoutControl from './SessionTimeoutControl.vue';
import KeyboardControl from './KeyboardControl.vue';
import IconControl from './IconControl.vue';
import mixin from '@/mixins/controls.js';
import user from '@/services/user';

export default {
    name: 'v-otp-modal',
    mixins: [mixin],
    inject: ['setLoading', 'setError', 'setMemberInfoLoading'],
    emits: ['otpValidated'],
    components: {
        LabelControl,
        ModalControl,
        KeypadControl,
        ButtonControl,
        IconControl,
        KeyboardControl,
        SessionTimeoutControl,
        EditPINModalControl,
        PrivacyPolicyControl
    },
    props: {
        type: {
            type: Number,
            default: 7,
            validator: (value) => [
                14, // TODO: enroll PIN
                6, // change email
                7, // change mobile
            ].includes(value),
        },
        otp_delay: {
            type: Number,
            default: parseInt(process.env.VUE_APP_OTP_DELAY, 10)
        },
        is_enrolling_pin: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        val(value) {
            this.$emit('ontyping', {
                name: this.name,
                value: value,
            })
        }
    },
    data() {
        return {
            beep: new Audio('https://resource.pafcpic.net/assets/pia/sounds/papsi_beep.mp3'),
            toggle_enroll_pin: false,
            is_modal_open: false,
            is_editing_info: false,
            is_requesting_otp: false,
            existing_session: false,
            toggle_message: false,
            toggle_privacy: false,
            phone_number: "",
            new_mobile: "",
            hash: "",
            uuid: "",
            otp: "",
            pin: "",
            email: "",
            new_email: "",
            enrollee_name: "",
            enrollee_mobile: "",
            enrollee_email: "",
            enrollee_uuid: "",
            enrollee_hash: "",
            modal_timeout: null,
            modal_countdown: this.otp_delay,
            modal_interval: null,
            can_resend_otp: false,
            loading: false,
            refresh_delay: parseInt(process.env.VUE_APP_REFRESH_DELAY, 10),
            disable_button: false,
            update_key: null,
        }
    },
    mounted() {
        const state = this.$store.state.user;
        this.full_name = `${state.first_name} ${state.middle_name} ${state.last_name}`;
        this.phone_number = state.mobile;
        this.hash = state.hash;
        this.tin = state.tin;
        this.qr = state.qr;
        this.uuid = state.uuid;
        this.email = state.email;

        const enrollee = this.$store.state.pin_enrollment;
        this.enrollee_mobile = enrollee.mobile; 
        this.enrollee_email = enrollee.email;
        this.enrollee_name = enrollee.name;
        this.enrollee_uuid = enrollee.uuid;
        this.enrollee_hash = enrollee.hash;
    },
    methods: {
        playBeep() {
            this.beep.play();
        },
        typing(object) {
            this[object.name] = object.value;
        },
        openEditModal() {
            this.is_modal_open = true;
            this.is_editing_info = true;

        },
        closeEditModal() {
            this.is_modal_open = false;
            this.is_editing_info = false;
            this.is_requesting_otp = false;
        },
        toggleMessage() {
            this.toggle_message = !this.toggle_message;
            this.otp = "";
        },
        startOTPCountdown() {
            this.can_resend_otp = false;
            this.modal_countdown = this.otp_delay;
            if (this.modal_interval) {
                clearInterval(this.modal_interval);
            }
            this.modal_interval = setInterval(() => {
                if (this.modal_countdown <= 0) {
                    clearInterval(this.modal_interval);
                    this.can_resend_otp = true;
                } else {
                    this.modal_countdown -= 1; // Decrement the countdown
                }
            }, 1000);
        },
        openRequestOTPModal() {
            this.is_modal_open = true;
            this.is_requesting_otp = true;
            this.requestPINOTP();
        },
        resendOTP() {
            // console.log('Resending OTP...');
            // console.log(this.type, this.can_resend_otp);
            if (this.can_resend_otp) {
                if (this.type == 7) {
                    this.requestMobileOTP();
                } else if (this.type == 6) {
                    this.requestEmailOTP();
                } else if (this.type == 14) {
                    this.openRequestOTPModal();
                }
            }
            this.can_resend_otp = false;
            this.startOTPCountdown();
        },
        toggleRequestOTP() {
            this.is_editing_info = false;
            this.is_requesting_otp = !this.is_requesting_otp;
            this.showInfo('OTP has been sent');
            this.startOTPCountdown();
        },
        toggleEditPINModal() {
            if (this.$refs.editPINModal) {
                this.$refs.editPINModal.openEditModal();
            } else {
                console.error('editPINModal ref is not available');
            }
        },
        saveDigits(mobile) {
            this.new_mobile = "+63" + mobile.join('');
        },
        updateDigits(mobile) {
            this.new_mobile = "+63" + mobile.join('');
        },
        clearDigits() {
            this.new_mobile = "";
        },
        clearPin() {
            this.otp = ''; // Clear the OTP when digits are cleared
        },
        updatePin(mobile) {
            this.otp = mobile.join(''); // Update the OTP with the current digits
        },
        saveOTP(OTP) {
            this.otp = OTP.join('');
        },
        validateEmail(email) {
            const email_regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (email != '' && email_regex.test(email)) {
                return true;
            }
            return false;
        },
        setModalLoading(status){
            this.loading = status;
            this.setMemberInfoLoading(status);
        },
        submitMobile() {
            this.playBeep();

            if (!this.new_mobile.startsWith('+639')) {
                this.showError('Invalid mobile number format');
                return;
            }

            this.setModalLoading(true);
            user.validateMobile(this.hash, this.new_mobile, this.uuid)
                .then((response) => {
                    this.toggleRequestOTP();
                    // this.requestMobileOTP();
                    this.update_key = response.data.data.hash;
                    this.pin = response.data.data.pin;
                })
                .catch((error) => {
                    if (error.response && error.response.status === 403) {
                        this.resetUserData();
                        this.clearUserCookie();
                        this.toggleExistingSessionModal();
                    }
                    this.showError(error.response.data.message);
                }).finally(() => {
                    this.setLoading(false);
                    // this.loading = false;
                    this.setModalLoading(false);
                });
        },
        requestPINOTP(){
            // console.log("Requesting OTP...");
            this.startOTPCountdown();
            user.requestPINOTP(this.enrollee_mobile, this.enrollee_email, this.enrollee_name, 14).then((response) => {
                this.pin = response.data.data.pin;
            }).catch((error) => {
                if (error.response && error.response.status === 403) {
                    this.resetUserData();
                    this.clearUserCookie();
                    this.toggleExistingSessionModal();
                }
                this.showError(error.response.data.message);
                this.setLoading(false);
            })
        },
        requestMobileOTP() {
            // console.log("Requesting Mobile OTP ...");
            user.requestMobileOTP(this.new_mobile, 7, this.pin).then((response) => {
                this.pin = response.data.data.pin;
            }).catch((error) => {
                if (error.response && error.response.status === 403) {
                    this.resetUserData();
                    this.clearUserCookie();
                    this.toggleExistingSessionModal();
                }
                this.showError(error.response.data.message);
                this.setLoading(false);
            })
        },
        requestEmailOTP() {
            // console.log("Requesting Email OTP...");
            user.requestEmailOTP(this.new_email, this.full_name, 6, this.pin).then((response) => {
                this.pin = response.data.data.pin;
            }).catch((error) => {
                if (error.response && error.response.status === 403) {
                    this.resetUserData();
                    this.clearUserCookie();
                    this.toggleExistingSessionModal();
                }
                this.showError(error.response.data.message);
                this.setLoading(false);
            })
        },
        submitEmail(email) {
            // this.loading = true; 
            this.setModalLoading(true);
            this.new_email = email;
            if (!this.validateEmail(this.new_email)) {
                this.showError("Invalid email format");
                // this.loading = false;
                this.setModalLoading(false);
                return;
            }
            user.validateEmail(this.hash, this.new_email, this.uuid)
                .then((response) => {
                    this.toggleRequestOTP();
                    // this.requestEmailOTP();
                    this.update_key = response.data.data.hash;
                    this.pin = response.data.data.pin;
                })
                .catch((error) => {
                    if (error.response && error.response.status === 403) {
                        this.resetUserData();
                        this.clearUserCookie();
                        
                        this.toggleExistingSessionModal();
                    }
                    this.showError(error.response.data.message);
                }).finally(() => {
                    this.setLoading(false);
                    // this.loading = false;
                    this.setModalLoading(false);
                });
        },
        validateOTP() {
            this.playBeep();
            this.disable_button = true;
            // console.log("Validating OTP...");
            user.validateOTP(this.otp, this.pin, this.type).then((response) => {
                // console.log("OTP Validation Response:", response);
                // console.log('TYPE: ', this.type);
                if (response && response.data && response.data.data) {
                    if (this.type == 7) { // Editing mobile number
                        user.editMobile(this.hash, this.new_mobile, response.data.data.otp_token, this.pin, this.uuid, this.update_key).then(() => {
                            this.$store.commit('updateMobile', this.new_mobile);
                            this.new_mobile = "";
                            this.showSuccess('Mobile number updated successfully!');
                            this.closeEditModal();
                            this.setLoading(false);
                        }).catch((error) => {
                            console.error("Edit Mobile Error:", error);
                            if (error.response && error.response.status === 403) {
                                this.resetUserData();
                                this.clearUserCookie();
                                this.toggleExistingSessionModal();
                            }
                            this.new_mobile = "";
                            this.closeEditModal();
                            this.setLoading(false);
                            this.showError(error.response?.data?.message || "An error occurred");
                        });
                    } else if (this.type == 6) { // Editing email address
                        user.editEmail(this.hash, this.new_email, response.data.data.otp_token, this.pin, this.uuid, this.update_key).then(() => {
                            this.$store.commit('updateEmail', this.new_email);
                            this.new_email = "";
                            this.showSuccess('Email Address updated successfully!');
                            this.openEditModal();
                            this.closeEditModal();
                            this.setLoading(false);
                        }).catch((error) => {
                            console.error("Edit Email Error:", error);
                            if (error.response && error.response.status === 403) {
                                this.resetUserData();
                                this.clearUserCookie();
                                this.toggleExistingSessionModal();
                            }
                            this.new_email = "";
                            this.closeEditModal();
                            this.setLoading(false);
                            this.showError(error.response?.data?.message || "An error occurred");
                        });
                    } else if (this.type == 14) { // Enrolling PIN
                        this.is_modal_open = false;
                        this.is_editing_info = false;
                        this.is_requesting_otp = false;
                        // console.log('otp token: ', response.data.data.otp_token);
                        // console.log('otp pin: ', response.data.data.otp_pin);
                        this.$store.state.pin_enrollment.otp_token = response.data.data.otp_token;
                        this.$store.state.pin_enrollment.otp_pin = response.data.data.otp_pin;
                        this.setLoading(false);
                        // this.disable_button = true;
                        this.$emit('otpValidated'); // Emit event here
                    }
                } else {
                    console.error("Unexpected response structure:", response);
                    this.showError("Unexpected response structure");
                    this.setLoading(false);
                }
            }).catch((error) => {
                console.error("OTP Validation Error:", error);
                if (error.response && error.response.status === 403) {
                    this.resetUserData();
                    this.clearUserCookie();
                    this.toggleExistingSessionModal();
                    this.disable_button = false;
                }
                this.showError(error.response?.data?.message || "An error occurred");
                this.setLoading(false);
                this.disable_button = false;
            });
        },
    },
    computed: {
        isButtonDisabled() {
            const expectedFormat = /^\+63\d{10}$/;
            return !expectedFormat.test(this.new_mobile);
        },
        isOTPValid() {
            return this.otp.length === 6;
        }
    }

};
</script>

<style scoped>
.verify-btn {
        width: 37rem !important; 
    }

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.animate-spin {
    animation: spin 1s linear infinite;
}

@media only screen and (min-width: 2500px) {
    .verify-btn {
        width: 60rem !important; 
    }
    .otp-button {width: 60rem !important; margin-top: -3rem !important;}
}
</style>
